module.exports = __webpack_public_path__ + "img/student_files_title.a4eac0b9.png";